<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Silenciar notificação da Categoria"
    :largura="700"
    @click:primary="salvar"
  >
    <template #ativador>
      <slot :callback="abrirDialog">
        <v-btn icon small @click.stop="abrirDialog">
          <v-icon :size="17">mdi-bell-off</v-icon>
        </v-btn>
      </slot>
    </template>

    <div>
      <v-radio-group
        class="dataradio"
        label="Silenciar a Categoria Até*"
        hide-details
        v-model="opcoes_periodos_fixos"
      >
        <v-row>
          <v-col v-for="periodo in periodos_fixos" col="2" :key="periodo.qtde_dias">
            <v-radio :label="periodo.descricao" :value="periodo.qtde_dias" />
          </v-col>
        </v-row>
      </v-radio-group>

      <v-text-field
        v-model="cadastro.data_limite"
        outlined
        type="date"
        @focus="opcoes_periodos_fixos = null"
        :error-messages="getMensagensValidacao('data_limite')"
      />

      <SysMotivosSilenciarAutocomplete
        v-model="cadastro.motivos"
        label="Motivos para silenciar a Categoria"
        outlined
        :error-messages="getMensagensValidacao('motivos')"
      />

      <div class="pl-1">
        <h4>Você pode silenciar a Categoria de 3 maneiras:</h4>

        <ul>
          <li>Por uma semana marcando a opção correspondente</li>
          <li>De 1 a 6 meses marcando a opção correspondente</li>
          <li>Informando uma data específica. Ex: 01/01/2021</li>
        </ul>
      </div>
    </div>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {required} from "vuelidate/lib/validators";
import SysMotivosSilenciarAutocomplete from "@/components/utils/crud/SysMotivosSilenciarAutocomplete.vue";
import * as ref from "@/api/compras/MateriaPrima/NotificacaoBlackList";
import {logout} from "@/helpers";

export default {
  components: {
    SysMotivosSilenciarAutocomplete,
    SysDialog
  },
  props: {
    idgrupo: Number,
    categorias: Array,
  },
  emits: ['categorias-silenciadas'],
  data: () => ({
    dialog_ativo: false,
    opcoes_periodos_fixos: null,
    cadastro: {
      data_limite: '',
      motivos: []
    },
    periodos_fixos: [
      { descricao: '1 semana', qtde_dias: 7 },
      { descricao: '1 mês', qtde_dias: 30 },
      { descricao: '2 mês', qtde_dias: 60 },
      { descricao: '3 mês', qtde_dias: 90 },
      { descricao: '6 mês', qtde_dias: 180 },
    ]
  }),
  validations: {
    cadastro: {
      data_limite: {
        required,
        data_limite_valida: function () {
          return new Date(this.cadastro.data_limite) > new Date();
        }
      },
      motivos: {
        required,
      }
    }
  },
  watch: {
    opcoes_periodos_fixos() {
      if (!this.opcoes_periodos_fixos) return;

      const data_atual = new Date();
      data_atual.setDate(data_atual.getDate() + this.opcoes_periodos_fixos);

      const mes = String(data_atual.getMonth() + 1).padStart(2, '0');
      const dia = String(data_atual.getDate()).padStart(2, '0');

      this.cadastro.data_limite = `${data_atual.getFullYear()}-${mes}-${dia}`;
    }
  },
  methods: {
    getMensagensValidacao(campo) {
      if (!this.$v.cadastro[campo].$dirty) return [];

      if ((this.$v.cadastro[campo].$params.required !== undefined) && !this.$v.cadastro[campo].required) {
        return  ["Campo Obrigatório."];
      }

      if ((this.$v.cadastro[campo].$params.data_limite_valida !== undefined) && !this.$v.cadastro[campo].data_limite_valida) {
        return  ["Data deve ser maior que hoje."];
      }

      return [];
    },
    abrirDialog() {
      this.dialog_ativo = true;
      this.buscarSilenciamentoAtual();
    },
    buscarSilenciamentoAtual() {
      if (this.categorias.length !== 1) return;

      const parametros = {
        grupo: this.idgrupo,
        filial: 9999,
        id_categoria: this.categorias[0],
      };

      this.$store.dispatch('loading/addRequisicao',
        ref.buscarCategoriasSilenciadas(parametros)
          .then(categorias => {
            if (categorias.length === 0) return;

            const [categoria] = categorias;
            this.cadastro.data_limite = categoria.data_limite;
            this.cadastro.motivos = categoria.motivos;
          })
          .catch(logout)
      );
    },
    salvar() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        grupo: this.idgrupo,
        filial: 9999,
        categorias: this.categorias,
        id_usuario: localStorage.id,
        data_limite: this.cadastro.data_limite,
        motivos: this.cadastro.motivos,
      };

      this.$store.dispatch('loading/addRequisicao',
        ref.salvarSilenciamentoCategoria(parametros)
          .then(this.resetarDialog)
          .catch(logout)
      );
    },
    resetarDialog() {
      this.dialog_ativo = false;
      this.opcoes_periodos_fixos = null;
      this.cadastro.data_limite = '';
      this.cadastro.motivos = [];
      this.$emit('categorias-silenciadas', {})
    }
  }
}
</script>
